import { render, staticRenderFns } from "./tag.vue?vue&type=template&id=acc974ea&"
import script from "./tag.vue?vue&type=script&lang=ts&"
export * from "./tag.vue?vue&type=script&lang=ts&"
import style0 from "./tag.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports